import { render, staticRenderFns } from "./JobPostCreate.vue?vue&type=template&id=d899638c&scoped=true&"
import script from "../../../services/company/job_post/job-post-create.js?vue&type=script&lang=js&"
export * from "../../../services/company/job_post/job-post-create.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/company.css?vue&type=style&index=0&id=d899638c&scoped=true&lang=css&"
import style1 from "@/assets/css/resume_detail.css?vue&type=style&index=1&id=d899638c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d899638c",
  null
  
)

export default component.exports